import { useGetFplConstantsByYearQuery } from "@/data/queries/fplConstantsQueries";
import { useListHouseholdMembersQuery } from "@/data/queries/householdMembersQueries";
import { dateAsDayjs } from "@/utils/date";

export const useHouseholdFpl = () => {
  const currentYear = dateAsDayjs().year();

  const { data: currentYearFplConstant } =
    useGetFplConstantsByYearQuery(currentYear);
  const { data: householdMembers } = useListHouseholdMembersQuery();

  const householdSize = householdMembers?.length ?? 0;

  const householdFpl = currentYearFplConstant
    ? currentYearFplConstant.individualAmount +
      (householdSize - 1) * currentYearFplConstant.additionalAmount
    : null;

  return householdFpl;
};
